import { DiJavascript1 } from 'react-icons/di';
import {
	FaBootstrap,
	FaCss3Alt,
	FaEnvelopeOpen,
	FaFacebookMessenger,
	FaGitAlt,
	FaGithub,
	FaHtml5,
	FaLaptopCode,
	FaLinkedinIn,
	FaMap,
	FaNode,
	FaPhoneAlt,
	FaReact,
	// FaRegHospital,
	FaSass,
	FaSlack,
	FaTelegram,
	FaToolbox,
	FaWhatsapp,
} from 'react-icons/fa';
import { GiOpenBook } from 'react-icons/gi';
import {
	SiAlpinedotjs,
	// SiAutodesk,
	SiExpress,
	SiJira,
	SiMongodb,
	SiMui,
	SiNextdotjs,
	SiReacthookform,
	SiRedis,
	SiRedux,
	SiShadcnui,
	SiTailwindcss,
	SiTanstack,
	SiTypescript,
	SiZod,
} from 'react-icons/si';
import basicCalculatorImg from '../Images/Projects/basic-calculator.png';
import caraShopingImg from '../Images/Projects/cara-shoping.jpg';
import currencyExchangeImg from '../Images/Projects/currency-exchange.jpg';
import devitaWatchsImg from '../Images/Projects/devita-watchs-full.jpg';
import ecommerceDashboardImg from '../Images/Projects/falcon-ecommerce-dashboard.webp';
import lusionShoppingImg from '../Images/Projects/react-lusion.jpg';
import sarahaAppImg from '../Images/Projects/saraha-app.webp';
import academyFrontendImg from '../Images/Projects/SEF-Academy-Trining-01.png';
import academyFullStackImg from '../Images/Projects/SEF-Academy-Trining-02.png';
import simpleMoviesImg from '../Images/Projects/Simple Movies-full.jpg';
import simpleMoviesReduxImg from '../Images/Projects/simple-movies-redux-full.jpg';
import sllmBlogImg from '../Images/Projects/SLLM Blogs-sllm-blog-redux.vercel.app.webp';
import Tamplate101DesignImg from '../Images/Projects/Tamplate-101-full.jpg';
import Tamplate102RocherImg from '../Images/Projects/Tamplate-102-Rocher-Furniture-full.jpg';
import coffeeKingImg from '../Images/Projects/Tamplate-103-CoffeeKing-Bootstrap-full.jpg';
import templateCarouselImg from '../Images/Projects/template-w-carouse.jpg';
import watchProductsImg from '../Images/Projects/watch-products.jpg';
// import { color } from "framer-motion";

export const startLink = '';
export const resumeLink = 'https://drive.google.com/file/d/1D0Fy5Pe73G_mcTDDA4iYf4_onrYOwhwU/view?usp=drive_link';
// direct download
// export const resumeLink = 'https://drive.google.com/uc?export=download&id=1D0Fy5Pe73G_mcTDDA4iYf4_onrYOwhwU';
// export const resumeLink = './files/MUSTAFA_Abutabl_resume.pdf';

export const myHomeData = {
	name: 'Mustafa Abutabl',
	job: 'Full Stack Web Developer',
	summery:
		'I’m an Egyptian Frontend Developer specializing in building responsive, mobile-first, and high-performance web applications using React, Next.js, Tailwind CSS, and JavaScript. Passionate about crafting clean, user-friendly interfaces, translating complex UI/UX designs into pixel-perfect solutions, and integrating APIs for seamless functionality. Experienced in performance optimization, version control (Git/GitHub), and delivering scalable, maintainable applications within Agile teams.',
};

export const myPersonalInfo = [
	{ id: 201, title: 'First Name', info: 'Mustafa' },
	{ id: 202, title: 'Last Name', info: 'Abutabl' },
	// { id: 203, title: 'Birthdate: ', info: '19 Oct 1989' },
	{ id: 204, title: 'Nationality', info: 'Egyption' },
	{ id: 205, title: 'Military Service', info: ' Finshed' },
	{ id: 206, title: 'Languages', info: 'Arabic, English' },
	{ id: 208, title: 'phone', info: '+20 111 970 6667', icon: 'phone', iconLink: 'tel:+201119706667' },
	{ id: 207, title: 'email', info: 'eng.mustafa@hotmail.com' },
	{ id: 209, title: 'Freelance', info: 'Available', color: '#01ef92' },
];

export const myContactInfo = [
	{ id: 301, title: 'Address', icon: FaMap, info: 'Cairo, Egypt', link: '' },
	{
		id: 302,
		title: 'Mail Me',
		icon: FaEnvelopeOpen,
		info: 'eng.mustafa@hotmail.com',
		link: 'mailto:eng.mustafa@hotmail.com',
	},
	{ id: 303, title: 'Call Me', icon: FaPhoneAlt, info: '+20 111 970 6667', link: 'tel:+201119706667' },
];

export const mySocialContact = [
	{ id: 311, title: 'Whatsapp', icon: FaWhatsapp, link: 'https://wa.me/201119706667' },
	{ id: 312, title: 'Github', icon: FaGithub, link: 'https://github.com/e-mustafa' },
	{ id: 313, title: 'Linkedin', icon: FaLinkedinIn, link: 'https://www.linkedin.com/in/e-mustafa' },
	// { id: 314, title: 'Facebook', icon: FaFacebookF, link: 'https://web.facebook.com/my.6000' },
	{ id: 315, title: 'messenger', icon: FaFacebookMessenger, link: 'https://m.me/my.6000' },
	{ id: 316, title: 'Telegram', icon: FaTelegram, link: 'https://t.me/eng_noo' },
];

export const skills = [
	{ id: 401, title: 'HTML', icon: <FaHtml5 />, color: '#e56229' },
	{ id: 402, title: 'CSS', icon: <FaCss3Alt />, color: '#007FFF' },
	{ id: 403, title: 'JavaScript', icon: <DiJavascript1 />, color: '#EAD41C' },
	{ id: 410, title: 'TypeScript', icon: <SiTypescript />, color: '#3178c6' },
	{ id: 404, title: 'React', icon: <FaReact />, color: '#00CEF2' },
	{ id: 405, title: 'Next', icon: <SiNextdotjs /> },
	{ id: 406, title: 'Alpine.js', icon: <SiAlpinedotjs />, color: '#77C1D2' },
	{ id: 407, title: 'Express', icon: <SiExpress /> },
	{ id: 408, title: 'MongoDB', icon: <SiMongodb />, color: '#4E9E42' },
	{ id: 409, title: 'Node.js', icon: <FaNode />, color: '#5CA74B' },
];

export const skills2 = [
	{ id: 301, title: 'Bootstrap', icon: <FaBootstrap />, color: '#733DBE' },
	{ id: 302, title: 'Material UI', icon: <SiMui />, color: '#007FFF' },
	{ id: 303, title: 'Tailwindcss', icon: <SiTailwindcss />, color: '#00bcff' },
	{ id: 304, title: 'Github', icon: <FaGithub /> },
	{ id: 305, title: 'Git', icon: <FaGitAlt />, color: '#DE4C36' },
	{ id: 306, title: 'Redux', icon: <SiRedux />, color: '#764ABC' },
	{ id: 307, title: 'SASS', icon: <FaSass />, color: '#c76494' },
	{ id: 308, title: 'Shadcn ui', icon: <SiShadcnui />, color: '#666666' },
	{ id: 309, title: 'Tanstack Query', icon: <SiTanstack />, color: '#FFB96D' },
	{ id: 310, title: 'Redis', icon: <SiRedis />, color: '#FF4438' },
	{ id: 311, title: 'Zod', icon: <SiZod />, color: '#408AFF' },
	{ id: 312, title: 'Redis', icon: <SiReacthookform />, color: '#EC5990' },
	{ id: 313, title: 'Jira', icon: <SiJira />, color: '#1868DB ' },
	{ id: 314, title: 'Slack', icon: <FaSlack />, color: '#36C5F0' },
];

export const timelineData = [
	{
		date: 'Jul/2024 - Present',
		title: 'Front-end web Developer',
		organization: 'Sllm for E-Commerce',
		icon: <FaToolbox />,
	},
	{
		date: 'Dec/2022 - Sep/2023',
		title: 'Front/Back-end Developer Diploma',
		organization: 'SEF Future',
		icon: <FaLaptopCode />,
	},
	{
		date: 'Feb/2022 - Aug/2022',
		title: 'Front-end Developer Diploma',
		organization: 'Pepo.Teck',
		icon: <FaLaptopCode />,
	},
	// {
	// 	date: 'Nov/2018 - Present',
	// 	title: '3D VISUALIZER',
	// 	organization: 'Freelancer',
	// 	icon: <SiAutodesk />,
	// },
	// {
	// 	date: 'Jul/2016 - Sep/2018',
	// 	title: 'Biomedical Engineer',
	// 	organization: 'Smama Group, Jeddah',
	// 	icon: <FaToolbox />,
	// },
	// {
	// 	date: 'Feb/2014 - Jul/2016',
	// 	title: 'Biomedical Engineer',
	// 	organization: 'Saad Ahmed Saad EST, Jeddah',
	// 	icon: <FaToolbox />,
	// },
	// {
	// 	date: 'Mar/2013 - Dec/2013',
	// 	title: 'Biomedical Engineer Trainee and Volunteer',
	// 	organization: 'International Medical Center, Jeddah',
	// 	icon: <FaRegHospital />,
	// },
	{
		date: '2007 - 2012',
		title: 'Medical Equipment Engineering',
		organization: 'Bachelor Degree',
		icon: <GiOpenBook />,
	},
];

export const myProjects = [
	{
		id: 119,
		title: 'Sarahah App - Full-Stack Anonymous Messaging ',
		img: sarahaAppImg,
		link: 'https://saraha-app-front.vercel.app/',
		githubLink: 'https://github.com/e-mustafa/saraha-app-frontend',
		backendLink: 'https://saraha-app-back.vercel.app/',
		backendGithub: 'https://github.com/e-mustafa/saraha-app',
		Language: ['HTML', 'CSS', 'tailwindcss', 'TypeScript', 'React', 'Node.js'],
		description:
			'Sarahah App is a modern full-stack anonymous messaging platform built with Next.js, Express.js, and MongoDB. It offers a secure and responsive user experience with JWT authentication, Google OAuth, automatic token refresh, and encrypted private messaging. Users can send anonymous or identified messages, upload images and audio recordings, organize messages into different categories, and publish selected messages publicly. The application supports Arabic and English, RTL/LTR layouts, dark mode, and a modular architecture designed for scalability and maintainability.',
	},
	{
		id: 118,
		title: 'E-commerce Dashboard – In Progress',
		img: ecommerceDashboardImg,
		// link: 'https://sllm-blog-redux.vercel.app/',
		githubLink: 'https://github.com/e-mustafa/nextjs15-dashboard-start',
		Language: ['HTML', 'CSS', 'tailwindcss', 'TypeScript', 'React', 'Node.js'],
		description:
			'E-commerce Dashboard is a modern administration dashboard built with Next.js and TypeScript. It provides a scalable and responsive interface for managing products, users, and application data through a modular architecture and reusable UI components. The project includes secure authentication, role-based access control, dynamic forms, advanced data tables, image management, internationalization with RTL/LTR support, dark mode, and efficient state management for a smooth user experience.',
	},
	// {
	// 	id: 117,
	// 	title: "Government Services Website",
	// 	img: governmentServicesImg,
	// 	link: null,
	// 	githubLink: "https://github.com/yourusername/government-services",
	// 	Language: ["HTML", "CSS", "JavaScript", "React", "Node.js", "Express", "MongoDB"],
	// 	description:
	// 		"Developed a government services website to facilitate the completion of official paperwork and procedures. As part of the Backend team, I built almost the entire project except for the users section. I developed APIs and managed databases for Blogs, Chat, Services, and Papers. Additionally, I contributed to the Frontend by completing the Papers section due to time constraints faced by the Frontend team.", // Project description
	// },

	{
		id: 117,
		title: 'Sllm Blog Website',
		img: sllmBlogImg,
		link: 'https://sllm-blog-redux.vercel.app/',
		githubLink: 'https://github.com/e-mustafa/sllm-blog-redux',
		Language: ['HTML', 'CSS', 'tailwindcss', 'JavaScript', 'React', 'Node.js'],
		description:
			'Sllm Blog is a modern, bilingual blog website developed using Next.js and Redux. It features a user-friendly and fully responsive interface, with dynamic SEO optimization tailored for each blog post. The platform supports both Arabic and English languages, allowing users to switch the language of each blog individually. In addition, it includes essential functionalities such as advanced search and seamless pagination to enhance the browsing experience.',
	},
	{
		id: 116,
		title: 'SEF Academy Website  (Full Stack Trining)',
		img: academyFullStackImg,
		link: 'https://project-01-seff-website-2023-09-2-my-part.vercel.app/',
		githubLink: 'https://github.com/e-mustafa/Project-01-SEFF_Website-2023-09--2-my-part',
		Language: ['HTML', 'CSS', 'Bootstrap', 'JavaScript', 'React', 'Node.js', 'Express', 'MongoDB'],
		description:
			'Contributed to the development of an SEF Academy Website as part of both the Frontend and Backend teams. Developed user interfaces using React and built APIs for Articles, Certificates, Exams, and Applications using Node.js and Express. Managed databases using MongoDB.',
	},
	{
		id: 115,
		title: 'SEF Academy Website (Frontend Trining)',
		img: academyFrontendImg,
		link: 'https://project-01-seff-website-2023-07-my-part.vercel.app/',
		githubLink: 'https://github.com/e-mustafa/Project-01-SEFF_Website-2023-07--my-part',
		Language: ['HTML', 'CSS', 'Bootstrap', 'JavaScript', 'React'],
		description:
			'Contributed to the development of the user interface for an SEF Academy Website as part of the Frontend team. Designed and implemented student registration pages, course displays, and grade tracking using React. Enhanced user experience with an interactive and smooth design.',
	},
	{
		id: 113,
		title: 'Devita Watchs',
		img: devitaWatchsImg,
		link: 'https://devita-watchs.vercel.app/',
		githubLink: 'https://github.com/e-mustafa/devita-watchs',
		Language: ['HTML', 'CSS', 'Material Ui', 'Javascript', 'React', 'Next'],
		description:
			'Online store for selling wristwatches, Developed using Next js 13 app dirctory, static & dynamic metadata, shopping cart, favorite list, With notifications toast.',
	},
	// {
	// 	id: 112,
	// 	title: "Mustafa Abutabl Portfolio",
	// 	img: coffeeKingImg,
	// 	link: "https://e-mustafa.github.io/Tamplate-103-CoffeeKing-Bootstrap",
	// 	githubLink:
	// 		"https://github.com/e-mustafa/Tamplate-103-CoffeeKing-Bootstrap",
	// 	Language: ["HTML", "CSS", "Bootstrap", "Javascript"],
	// 	description:
	// 		"Coffee shop template with edit bootstrap default colors and JavaScript shopping cart, favorite list, register and sign in with validate. With notifications toast. You need to register and sign in to checkout and add items to favorite list.",
	// },
	{
		id: 111,
		title: 'Coffee shop template',
		img: coffeeKingImg,
		link: 'https://e-mustafa.github.io/Tamplate-103-CoffeeKing-Bootstrap',
		githubLink: 'https://github.com/e-mustafa/Tamplate-103-CoffeeKing-Bootstrap',
		Language: ['HTML', 'CSS', 'Bootstrap', 'Javascript'],
		description:
			'Coffee shop template with edit bootstrap default colors and JavaScript shopping cart, favorite list, register and sign in with validate. With notifications toast. You need to register and sign in to checkout and add items to favorite list.',
	},
	{
		id: 110,
		title: 'Rocher-Furniture Tamplate',
		img: Tamplate102RocherImg,
		link: 'https://e-mustafa.github.io/Tamplate-102-Rocher-Furniture',
		githubLink: 'https://github.com/e-mustafa/Tamplate-102-Rocher-Furniture',
		Language: ['HTML5', 'CSS3'],
		description: 'Rocher-Furniture Tamplate html and some css3.',
	},
	{
		id: 109,
		title: 'Architectural Design Template',
		img: Tamplate101DesignImg,
		link: 'https://e-mustafa.github.io/Tamplate-101/',
		githubLink: 'https://github.com/e-mustafa/Tamplate-101',
		Language: ['HTML', 'CSS'],
		description: 'Architectur Design template html & css only.',
	},
	{
		id: 108,
		title: 'Simple Movies with Redux',
		img: simpleMoviesReduxImg,
		link: 'https://simplemovies-redux.netlify.app',
		githubLink: 'https://github.com/e-mustafa/moviesApp-redux',
		Language: ['HTML', 'CSS', 'Material Ui', 'Javascript', 'React', 'Redux'],
		description: 'Simple movies website to discover popular movies, and add to favorite list, with using Redux.',
	},
	{
		id: 107,
		title: 'Simple Movies',
		img: simpleMoviesImg,
		link: 'https://simplemovies-app.netlify.app',
		githubLink: 'https://github.com/e-mustafa/sempleMoviesApp',
		Language: ['HTML', 'CSS', 'Material Ui', 'Javascript', 'React'],
		description: 'Simple movies website to discover popular movies, and add to favorite list.',
	},
	{
		id: 106,
		title: 'Lusion Shopping',
		img: lusionShoppingImg,
		link: 'https://react-lusion-app.netlify.app',
		githubLink: 'https://github.com/e-mustafa/React-Lusion-App',
		Language: ['HTML', 'CSS', 'Bootstrap', 'Javascript', 'React'],
		description: 'Lustion ecommerce web responsive with many pages and form validation.',
	},
	{
		id: 105,
		title: 'Cara Shoping',
		img: caraShopingImg,
		link: 'https://cara-shoping.vercel.app',
		githubLink: 'https://github.com/e-mustafa/Cara-Shoping',
		Language: ['HTML', 'CSS', 'Bootstrap', 'Javascript'],
		description: 'responsive ecommerce website main page, sign up and sign in made with js.',
	},
	{
		id: 104,
		title: 'Currency Exchange',
		img: currencyExchangeImg,
		link: 'https://currency-exchange-mu.vercel.app',
		githubLink: 'https://github.com/e-mustafa/currencyExchange',
		Language: ['HTML', 'CSS', 'Bootstrap', 'Javascript'],
		description:
			'This is a simple Currency Converter application, I took help from this website, "exchangerate-api" to create an API connection.',
	},
	{
		id: 103,
		title: 'Basic Calculator',
		img: basicCalculatorImg,
		link: 'https://basic-calculator-self.vercel.app',
		githubLink: 'https://github.com/e-mustafa/basic-Calculator',
		Language: ['HTML', 'CSS', 'Bootstrap', 'Javascript'],
		description:
			'Basic Calculator for doing simple mathematical operations: addition, subtraction, multiplication, division. This is a simplified version of the online.',
	},
	{
		id: 102,
		title: 'Watch Products',
		img: watchProductsImg,
		link: 'https://watch-products.vercel.app',
		githubLink: 'https://github.com/e-mustafa/Watch-Products',
		Language: ['HTML', 'CSS', 'Bootstrap'],
		description: 'single page responsive website.',
	},
	{
		id: 101,
		title: 'Template W Carousel',
		img: templateCarouselImg,
		link: 'https://template-w-carousel.vercel.app',
		githubLink: 'https://github.com/e-mustafa/template-w-carousel',
		Language: ['HTML', 'CSS', 'Bootstrap'],
		description: 'single page responsive website.',
	},
];
